<template>
  <Modal :show="show" :prevent-backdrop-close="true" @close="handleCancel">
    <template #header>
      <div class="flex items-center gap-3">
        <!-- 图标 -->
        <div
          :class="[
            'flex-shrink-0 flex items-center justify-center w-12 h-12 rounded-full',
            typeClasses.bg
          ]"
        >
          <svg :class="['w-6 h-6', typeClasses.text]" fill="currentColor" viewBox="0 0 20 20">
            <path
              v-if="type === 'danger'"
              fill-rule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              clip-rule="evenodd"
            />
            <path
              v-else
              fill-rule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <span class="text-lg font-semibold dark:text-gray-100">{{ title }}</span>
      </div>
    </template>

    <template #body>
      <div class="mt-2">
        <p class="text-sm text-gray-600 dark:text-gray-400">{{ message }}</p>
      </div>
    </template>

    <template #footer>
      <div class="flex gap-3 justify-end">
        <button
          @click="handleCancel"
          class="cancel-btn"
        >
          {{ cancelText }}
        </button>
        <button
          @click="handleConfirm"
          :class="type === 'danger' ? 'danger-btn' : 'primary-btn'"
        >
          {{ confirmText }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import Modal from './Modal.vue';

/**
 * Props 定义
 */
interface Props {
  show: boolean;
  type?: 'info' | 'danger';
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

const props = withDefaults(defineProps<Props>(), {
  type: 'info',
  title: '确认操作',
  confirmText: '确认',
  cancelText: '取消',
});

/**
 * Emits 定义
 */
const emit = defineEmits<{
  confirm: [];
  cancel: [];
}>();

/**
 * 类型对应的样式类
 */
const typeClasses = computed(() => {
  if (props.type === 'danger') {
    return {
      bg: 'bg-red-100 dark:bg-red-900/30',
      text: 'text-red-600 dark:text-red-400',
    };
  }
  return {
    bg: 'bg-blue-100 dark:bg-blue-900/30',
    text: 'text-blue-600 dark:text-blue-400',
  };
});

/**
 * 处理确认
 */
const handleConfirm = () => {
  emit('confirm');
};

/**
 * 处理取消
 */
const handleCancel = () => {
  emit('cancel');
};
</script>

